import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CameraFilledIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M9.27273 4H14.7273L16.5455 5.81818H20.1818C20.664 5.81818 21.1265 6.00974 21.4675 6.35071C21.8084 6.69169 22 7.15415 22 7.63636V18.5455C22 19.0277 21.8084 19.4901 21.4675 19.8311C21.1265 20.1721 20.664 20.3636 20.1818 20.3636H3.81818C3.33597 20.3636 2.87351 20.1721 2.53253 19.8311C2.19156 19.4901 2 19.0277 2 18.5455V7.63636C2 7.15415 2.19156 6.69169 2.53253 6.35071C2.87351 6.00974 3.33597 5.81818 3.81818 5.81818H7.45455L9.27273 4ZM12 17.6364C13.2055 17.6364 14.3617 17.1575 15.2141 16.305C16.0666 15.4526 16.5455 14.2964 16.5455 13.0909C16.5455 11.8854 16.0666 10.7292 15.2141 9.87679C14.3617 9.02435 13.2055 8.54545 12 8.54545C10.7945 8.54545 9.63832 9.02435 8.78588 9.87679C7.93344 10.7292 7.45455 11.8854 7.45455 13.0909C7.45455 14.2964 7.93344 15.4526 8.78588 16.305C9.63832 17.1575 10.7945 17.6364 12 17.6364ZM12 15.8182C11.2767 15.8182 10.583 15.5308 10.0715 15.0194C9.56006 14.5079 9.27273 13.8142 9.27273 13.0909C9.27273 12.3676 9.56006 11.6739 10.0715 11.1624C10.583 10.651 11.2767 10.3636 12 10.3636C12.7233 10.3636 13.417 10.651 13.9285 11.1624C14.4399 11.6739 14.7273 12.3676 14.7273 13.0909C14.7273 13.8142 14.4399 14.5079 13.9285 15.0194C13.417 15.5308 12.7233 15.8182 12 15.8182Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CameraFilledIcon.displayName = 'CameraFilledIcon';
